/* core components */
import React, { useContext } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { AutocompleteValidator } from "utils/Validators/CommonValidator";
//import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import TextField from "@material-ui/core/TextField";
import { UserInfoContext } from "contexts/users";
import { Validate } from "utils/Validators/Validate";
import conf from "config/env.conf.js";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxDistinct = props => {
  const [, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");
  const [valid, setValid] = React.useState();
  const userInfo = useContext(UserInfoContext);

  let provinceId =
    props.provinceSelected &&
    props.provinceSelected.id &&
    props.provinceSelected.id !== undefined
      ? props.provinceSelected.id
      : userInfo.userInfo.isCenter
      ? userInfo.userInfo.provinceId
      : 0;

  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + "/ms/amphures?province_id=" + provinceId,
    [props.provinceSelected]
  );

  let content = (
    <TextField
      disabled
      label={props.title ? props.title : "เลือกอำเภอ"}
      margin="normal"
      fullWidth
    />
  );

  let data = [];

  if (
    provinceId !== 0 &&
    !isLoading &&
    fetchData !== null &&
    fetchData.data !== undefined
  ) {
    data = fetchData.data.map(v => {
      return { id: v.amphur_id, value: v.amphur_name };
    });
    if (props.controll) {
      data = [{ id: 0, value: "" }, ...data];
    }
    data = [{ id: 0, value: "" }, ...data];
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        id="listBoxDistinct"
        disabled={props.disabled}
        options={data}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value && props.value.id === 0 ? data[0] : props.value}
        // value={props.value}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={AutocompleteValidator(
          props.onChange,
          props.validators,
          setError,
          setHelperText
        )}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label={props.title ? props.title : "เลือกอำเภอ"}
              margin="normal"
              error={valid}
              fullWidth
              helperText={helperText}
              inputProps={{
                autoComplete: "new-password",
                //   autoComplete: "off",
                ...params.inputProps
              }}
              onChange={Validate(
                params.inputProps.value,
                props.required,
                setValid
              )}
              required={props.required}
            />
          );
        }}
        {...props.customProps}
      />
    );
  }
  return content;
};
export default ListboxDistinct;
